import React from 'react'
import "./mobilesearch.css"
import { Container, Row, Col } from 'react-bootstrap'

function MobileBlogSearch({ blogData, onClick }) {
    return (
        <>
            <div onClick={onClick}>
                <Container>
                    <Row>
                        <Col md={12} xs={12} >
                            <a href={`http://wisemonkeys.info/blog/${blogData.slug}`} className="block mb-3 shadow overflow-hidden hover:shadow">
                                <div className="container-fluid">
                                    <div className="row items-center">
                                        <div className="col-md-5 px-2 py-2">
                                            <div className=" p-2 border rounded-xl">
                                                <img src={blogData.banner_image} alt="blogHeroImage" className="w-full h-28 object-cover" />
                                            </div>
                                        </div>
                                        <div className="col-md-7">
                                            <div className="py-3">
                                                <p className="manpro text-base text-black wordClamp-2 mb-3">{blogData.blog_title}</p>
                                                <div className="flex space-x-3 items-center">
                                                    <div className="w-10 h-10 rounded-full bg-gray-300">
                                                        <img src={blogData.profile_photo} alt="profile" className="w-10 h-10 rounded-full" />
                                                    </div>
                                                    <div>
                                                        <span className="block manpro text-black font-semibold text-sm">{blogData.full_name}</span>
                                                        <span className="block manpro text-black font-medium text-xs">{blogData.username}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </a>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default MobileBlogSearch
